import {
  Sparkles,
  ShieldCheck,
  HeartPulse,
  Wrench,
  Factory,
  Building2,
} from "lucide-react";

const map = { Sparkles, ShieldCheck, HeartPulse, Wrench, Factory, Building2 };

export default function ServiceIcon({ name, ...props }) {
  const Cmp = map[name] || Sparkles;
  return <Cmp {...props} />;
}
